module.exports = __webpack_public_path__ + "img/img_display_mode_two.e43686ab.png";